module.exports = __webpack_public_path__ + "static/media/soulfood.05431354.jpg";